import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  IQuestionnaireChoice,
  IQuestionnaireQuestion,
} from 'src/app/interfaces/Questionnaire/IQuestionnaire';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-slag-questions',
  templateUrl: './slag-questions.component.html',
  styleUrl: './slag-questions.component.css',
  standalone: false,
})
export class SlagQuestionsComponent implements OnInit {
  @Input() elements: IQuestionnaireQuestion[] = [];
  @Input() formGroup!: FormGroup;
  @Input() readonlyMode = false;

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly translate: TranslateService,
    private readonly permissionService: PermissionService,
  ) {}

  ngOnInit(): void {}

  isInpatientView(): boolean {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }

  isEOC() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('episodeOfCare')
    );
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  setNotMentioned(fieldName: string): void {
    this.formGroup
      .get(fieldName)
      ?.setValue(this.translate.instant('Not mentioned'));
    this.cdr.detectChanges();
  }

  onRadioClick(controlName: string, value: any): void {
    if (this.readonlyMode) return;

    const control = this.formGroup.get(controlName);
    if (!control) return;

    if (control.value === value) {
      control.setValue(null);
    }
  }

  isCheckboxSelected(controlName: string, value: string): boolean {
    const controlValue = this.formGroup.get(controlName)?.value;
    return Array.isArray(controlValue) && controlValue.includes(value);
  }

  onCheckboxChange(controlName: string, value: string, checked: boolean): void {
    if (this.readonlyMode) return;

    const control = this.formGroup.get(controlName);
    if (!control) return;

    const currentValue = Array.isArray(control.value) ? [...control.value] : [];

    if (checked) {
      if (!currentValue.includes(value)) {
        currentValue.push(value);
      }
    } else {
      const index = currentValue.indexOf(value);
      if (index >= 0) {
        currentValue.splice(index, 1);
      }
    }

    control.setValue(currentValue);
  }

  getChoiceLabel(choice: IQuestionnaireChoice): string {
    return choice.text ?? choice.value ?? '';
  }

  getQuestionTitle(title?: string): string {
    return title?.split('||')[0]?.trim() ?? '';
  }

  getQuestionInstruction(title?: string): string {
    return title?.split('||')[1]?.trim() ?? '';
  }
}
